// ==============================|| ВРЕМЕННО СКРЫТЫЙ UI ||============================== //
//
// Словарь: присутствие ключа со значением true — соответствующий блок не показываем.
// Удалите ключ или поставьте false, чтобы снова показать.
//
// modules — группа «Модули системы» в меню, пункт «Управление модулями» в проектах,
//           блок модулей на форме клона.
// attributes — пункт «Управление атрибутами» в меню, блок атрибутов на форме клона.

/** @typedef {'modules' | 'attributes'} HiddenUiKey */

/** @type {Partial<Record<HiddenUiKey, boolean>>} */
export const HIDDEN_UI = {
  modules: true,
  attributes: true
};

/**
 * @param {HiddenUiKey} key
 * @returns {boolean}
 */
export function isUiHidden(key) {
  return Boolean(HIDDEN_UI[key]);
}
